var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mx-auto px-4 py-8"},[_c('div',{staticClass:"bg-white rounded-lg shadow-md p-6"},[_c('p',[_vm._v("Set your app language here")]),_c('div',{staticClass:"block",attrs:{"id":"google_translate_element"}})])])
}]

export { render, staticRenderFns }